const commonParticulars: {
  [key: string]: {
    key: string;
    description: string;
  };
} = {
  fee: {
    key: 'managementfee',
    description: 'Fixed Management Fees based on AUM',
  },
  charges: {
    key: 'charges',
    description: 'Custodian Fees, Depository Charges & Fund Accounting Charges',
  },
  taxes: {
    key: 'taxes',
    description: 'Securities Transaction Tax / Audit Charges / Brokerage &Allied Charges / Levies',
  },
};

export const particulars: {
  [key: string]: {
    [key: string]: {
      key: string;
      description: string;
    };
  };
} = {
  Fixed: {
    ...commonParticulars,
  },
  Hybrid: {
    ...commonParticulars,
    performanceFee: {
      key: 'performanceFee',
      description: 'Performance Based Management Fees -Variable Fees (at the end of tenure)',
    },
  },
};
